// removed by extract-text-webpack-plugin
module.exports = {"container":"otdJ2duGLa2wB0TavFGYG","barLeft":"_29pmcghV6gWUfDsNCoMSZe","iconTop":"_3XiA07JEy0qqatuks_S1K6","textV":"_3bJLL_zzqzY-ygQtNUV4V_","actionIcon":"_3F3i7Cv-rpOYYd7l6lk5Nz","content":"_7gZXAf9krJ-hV5egcV3YE","date":"mqGomQxKY_XJKV2W2Bart","title":"_2vdMrS6xTaEpcmEUlatibI","location":"_2hBrcqeImt7ZMoNbyAbaLy","city":"_2SPAvMwwVpxFAwxzmC5yaQ"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/molecules/BoxEvent/style.css
// module id = 292
// module chunks = 37